import { GlobalStyles } from '@contentful/f36-components';
import { SDKProvider } from '@contentful/react-apps-toolkit';

import { createRoot } from 'react-dom/client';
import App from './App';
import LocalhostWarning from './components/LocalhostWarning';
import { AuthProvider } from './components/AuthProvider';

const container = document.getElementById('root')!;
const root = createRoot(container);

if (process.env.NODE_ENV === 'development' && window.self === window.top) {
  // You can remove this if block before deploying your app
  root.render(<LocalhostWarning />);
  //To debug in local host, enable this line instead of above
  // root.render(<AuthProvider />);
} else {
  root.render(
    <AuthProvider>
      <SDKProvider>
        <GlobalStyles />
        <App />
      </SDKProvider>
    </AuthProvider>
  );
}
